<template>
  <div class="w-100">
    <component
      :is="VuePaypalButtons"
      :style="styleObj"
      :on-init="onInit"
      :on-approve="onApprove"
      :create-order="subscription ? null : createOrder"
      :create-subscription="subscription ? createSubscription : null"
      :on-click="onClick"
      :on-cancel="onCancel"
      :on-shipping-change="onShippingChange"
      :on-error="onError"
    />
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'PayPalButtons',
  props: {
    locale: {
      type: String,
      default: 'en'
    },
    amount: {
      type: String,
      default: 'USD'
    },
    currency: {
      type: String,
      default: 'USD'
    },
    subscription: {
      type: Boolean,
      default: false
    },
    taxDeductible: {
      type: Boolean,
      default: false
    },
    styleObj: {
      type: Object,
      default: () => {}
    },
    onInit: {
      type: Function,
      default: () => {}
    },
    createOrder: {
      type: Function,
      default: () => {}
    },
    createSubscription: {
      type: Function,
      default: () => {}
    },
    onApprove: {
      type: Function,
      required: true
    },
    onClick: {
      type: Function,
      default: () => {}
    },
    onCancel: {
      type: Function,
      default: () => {}
    },
    onShippingChange: {
      type: Function,
      default: () => {}
    },
    onError: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    scriptNode: null,
    VuePaypalButtons: null
  }),
  computed: {
    paypalLocale() {
      // Paypal has a low tolerance for vague locale codes so here we extend ours to
      // the 5 char full format such as en_US
      const tokens = this.locale.split('-')
      if (tokens.length > 1) {
        return `${tokens[0]}_${tokens.splice(1).join(`_`).toUpperCase()}`
      } else if (this.locale === 'en') {
        return 'en_US'
      } else {
        return `${this.locale}_${this.locale.toUpperCase()}`
      }
    }
  },
  destroyed() {
    window.paypal && window.paypal.Buttons && window.paypal.Buttons().close()
    this.$emit('paypal', null)
  },
  methods: {
    getScriptSrc() {
      // https://developer.paypal.com/docs/checkout/reference/customize-sdk/
      const { currency, paypalLocale } = this
      const clientId = this.taxDeductible
        ? (process.env.VUE_APP_PAYPAL_C3_CLIENT_ID || process.env.paypalClientIdC3 || 'sb')
        : (process.env.VUE_APP_PAYPAL_CLIENT_ID || process.env.paypalClientId || 'sb')
      const urlSearchParams = new URLSearchParams({
        'client-id': clientId,
        currency,
        'enable-funding': 'paypal',
        'disable-funding': 'card',
        locale: paypalLocale,
        intent: this.subscription ? 'subscription' : 'capture',
        vault: this.subscription
      })
      if (process.env.VUE_APP_PAYPAL_DEBUG) {
        urlSearchParams.append('debug', 'true')
      }
      return 'https://www.paypal.com/sdk/js?' + urlSearchParams.toString()
    },
    onScriptLoad(evt) {
      if (window.paypal && window.paypal.Buttons) {
        this.VuePaypalButtons = window.paypal.Buttons.driver('vue', Vue)
        this.$emit('paypal-ready', window.paypal)
      } else {
        // eslint-disable-next-line no-console
        // eslint-disable-next-line no-console
        console.error('window.paypal.Buttons not defined')
      }
    }
  },
  head() {
    const script = [
      {
        src: this.getScriptSrc(),
        callback: this.onScriptLoad,
        hid: 'paypal'
      }
    ]
    return { script }
  }
}
</script>
